export const users = {
    state: {
        status: 'idle',
        users: [],
        areAllFetched: false,
        pagination: {
            limit: 20,
            page: 1
        }
    },
    mutations: {
        SET_USERS_STATUS(state, status) {
            state.status = status
        },
        SET_USERS(state, users) {
            state.users = users
        },
        SET_USERS_PAGINATION_PAGE(state, page) {
            state.pagination.page = page
        },
        SET_USERS_ALL_FETCHED(state, areAllFetched) {
            state.areAllFetched = areAllFetched
        }
    },
    actions: {
        fetchUsers({ state, commit, dispatch }) {
            commit('SET_USERS', [])
            commit('SET_USERS_STATUS', 'loading')
            const pagination = `page=${state.pagination.page}&limit=${state.pagination.limit}`

            return dispatch('resetUsersPagination').then(() => {
                return this.$api.get(`api/users.json?${pagination}`).then((response) => {
                    commit('SET_USERS', response.data.data)
                    commit('SET_USERS_ALL_FETCHED', response.data.total_count ? response.data.total_count <= state.users.length : response.data.data.length === 0)
                    commit('SET_USERS_STATUS', 'idle')
                }).catch(error => {
                    commit('SET_USERS_STATUS', 'error')
                    return Promise.reject(error)
                })
            })
        },
        fetchUsersNextPage({ state, commit }) {
            if(state.areAllFetched) {
                return false
            }
            const pagination = `page=${state.pagination.page}&limit=${state.pagination.limit}`
            commit('SET_USERS_STATUS', 'loadingMore')
            commit('SET_USERS_PAGINATION_PAGE', state.pagination.page + 1)
            return this.$api.get(`api/users.json?${pagination}`).then((response) => {
                commit('SET_USERS', state.users.concat(...response.data.data))
                commit('SET_USERS_ALL_FETCHED', response.data.total_count ? response.data.total_count <= state.users.length : response.data.data.length === 0)
                commit('SET_USERS_STATUS', 'idle')
            }).catch(error => {
                commit('SET_USERS_STATUS', 'error')
                return Promise.reject(error)
            })
        },
        resetUsersPagination({ commit, dispatch }) {
            commit('SET_USERS_ALL_FETCHED', false)
            return dispatch('resetFromInitialState', {
                module: 'users',
                object: 'pagination'
            })
        }
    },
    getters: {
        usersStatus: (state) => {
            return state.status
        },
        users: (state) => {
            if(state.users) {
                return state.users
            }
        }
    }
}
